import React, { useState, useEffect } from 'react';
import { Api } from '../../../services/api';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const ProductionSetting = ({ visible, closeModel, onSuccess }) => {
    const [pmCapacity, setPmCapacity] = useState(0);
    const [pmAvailable, setPmAvailable] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (visible) {
            getProjectDetails();
        }
    }, [visible]);

    const getProjectDetails = () => {
        setIsLoading(true);
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(Api.API_BASE_URL + 'get-pm-capacity', {
            method: "GET",
            headers: headers
        })
            .then((response) => response.json())
            .then((response) => {
                setPmAvailable(response.result.pm_availble);
                setPmCapacity(response.result.pm_capacity);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
                setError(error.message);
            });
    }

    const handleUpdate = async (event) => {
        event.preventDefault();
        try {
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            const response = await fetch(Api.API_BASE_URL + 'save-pm-capacity', {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ pm_capacity: pmCapacity, pm_availble: pmAvailable }),
            });
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            const data = await response.json();
            console.log(data);
            closeModel();
            onSuccess();
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <Dialog header="Production Setting" headerClassName="centered-header" visible={visible} maximizable style={{ width: '20vw' }} dismissableMask={true} onHide={closeModel}>
            <div className="p-4 ">
                <form onSubmit={handleUpdate}>

                    <div className="mb-4 flex items-center  gap-4">
                        <label className="block text-gray-800 text-md mb-2">PM Capacity:</label>
                        <input
                            type="number"
                            className="w-3/6 input-field"
                            value={pmCapacity}
                            onChange={(event) => setPmCapacity(event.target.value)}
                        />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <Button className="customSave-button mt-4" type="submit">Update</Button>
                    </div>

                </form>
            </div>
        </Dialog>
    );
};

export default ProductionSetting;


